import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface projectState {
    projectTypeMenu: string[],
    projectType: string,
    selectedProject: selectedProjectType | null,
    projects_trackedTime: Record<string, number>,

    filterIssueTypeId: string
    filterIssueCompleteShow: boolean,
    startDate: string,
    endDate: string,
    searchIssueText: string
    showCompleted: boolean,
    showPending: boolean,
    createdBy: boolean,
    allOpen: boolean,
    recentlyCreated: boolean,
    overDue: boolean,
    newProjectCreated: boolean;
}

export interface selectedProjectType {

    //for  open project
    id: string
    name: string
    _links: Record<string, any>

    projectSpentTimeInsecond: number
    projectLink: string

    task_project_commonFieldForSpentTime: string

    _type?: string
    identifier?: string
    active?: boolean
    public?: boolean
    description?: Description
    createdAt?: string
    updatedAt?: string


    // for jira project
    projectKey?: string

}

export interface Description {
    format: string
    raw: string
    html: string
}

export const initialState: projectState = {
    projectTypeMenu: ['WayMore Project', 'WayMore CRM', 'Jira'],
    projectType: 'WayMore Project',
    selectedProject: null,
    projects_trackedTime: {},
    startDate: '',
    endDate: '',
    filterIssueTypeId: '',
    filterIssueCompleteShow: false,
    searchIssueText: '',
    showCompleted: false,
    showPending: false,
    createdBy: false,
    allOpen: false,
    recentlyCreated: false,
    overDue: false,
    newProjectCreated: false
}

export const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        setProjectType: (state, action: PayloadAction<string>) => {
            state.projectType = action.payload
        },
        setStateSelectedProject: (state, action: PayloadAction<selectedProjectType | null>) => {
            state.selectedProject = action.payload
        },
        setProjectTrackedTime: (state, action: PayloadAction<Record<string, number>>) => {
            let oldData = { ...state.projects_trackedTime }
            state.projects_trackedTime = { ...oldData, ...action.payload }
        },

        setFilterIssueTypeId: (state, action: PayloadAction<string>) => {
            state.filterIssueTypeId = action.payload
        },
        setFilterIssueCompleteShow: (state, action: PayloadAction<boolean>) => {
            state.filterIssueCompleteShow = action.payload
        },
        setSearchIssueText: (state, action: PayloadAction<string>) => {
            state.searchIssueText = action.payload
        },
        setStartDate: (state, action: PayloadAction<string>) => {
            state.startDate = action.payload
        },
        setEndDate: (state, action: PayloadAction<string>) => {
            state.endDate = action.payload
        },
        clearProjectState: (state) => {
            state = structuredClone(initialState);
        },
        setShowPendingTasks: (state, action: PayloadAction<boolean>) => {
            state.showPending = action.payload
        },
        setShowCompletedTasks: (state, action: PayloadAction<boolean>) => {
            state.showCompleted = action.payload
        },
        setCreatedBy: (state, action: PayloadAction<boolean>) => {
            state.createdBy = action.payload
        },
        setAllOpen: (state, action: PayloadAction<boolean>) => {
            state.allOpen = action.payload
        },
        setRecentlyCreated: (state, action: PayloadAction<boolean>) => {
            state.recentlyCreated = action.payload
        },
        setOverDue: (state, action: PayloadAction<boolean>) => {
            state.overDue = action.payload
        },
        setNewProjectCreated: (state, action: PayloadAction<boolean>) => {
            state.newProjectCreated = action.payload;
        }
    },
    selectors: {
        getProjectType: (state) => {
            return state.projectType;
        }
    }
});

export const {
    setStateSelectedProject,
    setProjectTrackedTime,
    setProjectType,
    setFilterIssueTypeId,
    setFilterIssueCompleteShow,
    setSearchIssueText,
    clearProjectState,
    setShowPendingTasks,
    setStartDate,
    setEndDate,
    setShowCompletedTasks,
    setOverDue,
    setAllOpen,
    setRecentlyCreated,
    setCreatedBy,
    setNewProjectCreated

} = projectSlice.actions;

export const { getProjectType } = projectSlice.selectors;

export default projectSlice.reducer;